<template>
  <div class="finance">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <jm-crumbs/>
          <jm-toolbar customize-field-name="order" show-defined-list/>

          <div class="table-agile-info">
            <el-alert type="success" title="本页为历史数据，仅供参考。2022年前的未确认交易尚未全部同步至新版“订单系统”，可通过手工报账导入新系统。" />
            <div class="searchList">
              <div class="box-content">
                <label class="form-tit">产品名称</label>
                <el-input
                  v-model="searchData['goods_label']"
                  class="jm-input220"/>
              </div>
              <div class="box-content">
                <label class="form-tit">订单编号</label>
                <el-input
                  v-model="searchData['order_number']"
                  class="jm-input220"/>
              </div>
              <div class="box-content">
                <label class="form-tit">合同编号</label>
                <el-input
                  v-model="searchData['contract_number']"
                  class="jm-input220"/>
              </div>
              <div class="box-content">
                <label class="form-tit">付款方式</label>
                <el-select
                  v-model="searchData['payment_method']"
                  class="jm-input220"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="(item, key) in dropdownData.payment_method"
                    :value="item.id"
                    :key="key"
                    :label="item.value"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">支付状态</label>
                <el-select
                  v-model="searchData['order_status']"
                  class="jm-input220"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="(item, key) in dropdownData.pay_status"
                    :value="item.id"
                    :key="key"
                    :label="item.value"/>
                </el-select>
              </div>
              <div class="box-content" v-if="searchData['order_status'] === 2">
                <label class="form-tit">支付时间</label>
                <el-date-picker
                  v-model="searchData['pay_time_range']"
                  type="daterange"
                  placeholder="选择日期"
                  class="jm-input220" />
              </div>
              <div class="box-content">
                <label class="form-tit">学生姓名</label>
                <el-input
                  v-model="searchData['username']"
                  class="jm-input220"/>
              </div>
              <div class="box-content">
                <label class="form-tit">发起老师</label>
                <el-select
                  filterable
                  v-model="searchData['create_uid']"
                  class="jm-input220"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="(item, key) in dropdownData.create_uid"
                    :value="item.userid"
                    :key="key"
                    :label="item.truename"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">财务确认</label>
                <el-select
                  v-model="searchData['finance_status']"
                  class="jm-input220"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="(item, key) in dropdownData.finance_status"
                    :value="item.id"
                    :key="key"
                    :label="item.value"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">渠道来源</label>
                <el-select
                  v-model="searchData['channel']"
                  class="jm-input220"
                  clearable
                  placeholder="请选择">
                  <el-option
                    v-for="(item, key) in dropdownData.channel"
                    :value="item.id"
                    :key="key"
                    :label="item.value"/>
                </el-select>
              </div>
              <div class="box-content">
                <label class="form-tit">是否公海</label>
                <el-select
                  v-model="searchData['is_waters']"
                  class="jm-input220"
                  clearable
                  placeholder="请选择">
                  <el-option :key="1" label="是" :value="1"/>
                  <el-option :key="2" label="否" :value="2"/>
                </el-select>
              </div>

              <div class="search-btn">
                <el-button
                  @click="orderSubmit"
                  class="jm-input135"
                  type="primary">搜索</el-button>
              </div>
            </div>
            <!--搜索结果-->
            <jm-tableList
              url="/index/order/pagetable"
              :search-data="searchData"
              :refresh.sync="refresh"
            >
              <el-table-column
                slot="custom_name"
                slot-scope="scope"
                :label="scope.label"
                property="custom_name">
                <template slot-scope="scope">
                  <el-tag
                    type="gray"
                    v-if="scope.row.is_waters > 0">海</el-tag>
                  {{ scope.row.custom_name }}
                </template>
              </el-table-column>
              <el-table-column
                slot="law_status"
                label="法务确认" >
                <template slot-scope="scope">
                  <span :class="[scope.row.law_status === '已确认' ? 'red' : '']">
                    {{ scope.row.order_method === 2 ? scope.row.law_status : '--' }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                slot="finance_status"
                label="财务确认" >
                <template slot-scope="scope">
                  <span :class="[scope.row.finance_status === '已确认' ? 'red' : '']">{{ scope.row.finance_status }}</span>
                </template>
              </el-table-column>
              <el-table-column
                slot="order_status"
                label="支付状态" >
                <template slot-scope="scope">
                  <span :class="[scope.row.order_status === '已付款' ? 'red' : '']">{{ scope.row.order_status }}</span>
                </template>
              </el-table-column>
            </jm-tableList>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import toolbar from '@/components/tool/toolbar';
import tableList from '@/components/data/tableList.vue';

export default {
  data() {
    return {
      searchData: {
        goods_label: null,
      }, // 搜索条件
      dropdownData: {},
      goods_name_value: null,
      refresh: false,
      currentPage: 1,
    };
  },
  methods: {
    /**
     * Description: 搜索条件初始化数据
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getSearch() {
      return new Promise((resolve) => {
        this.$http._get({
          url: '/index/order/searchDs'
        }).then(({ data }) => {
          resolve(data);
        });
      });
    },
    /**
     * Description: 产品搜索
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    // querySearchAsync(name, cb) {
    //   if (name === '') {
    //     this.searchData.goods_name = '';
    //   }
    //   this.searchData.goods_label = name;
    //   this.$http._get({
    //     url: `/index/order/queryService?q=${name}`,
    //   }).then(({ data }) => {
    //     const schoolData = Array.isArray(data) ? data : Object.keys(data);
    //     cb(schoolData);
    //   });
    // },
    /**
     * Description: 产品搜索 赋值value
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleSelect(item) {
      let subItem = item.label.substring(item.label.indexOf(')') + 1);
      let subTowItem = subItem.substring(0, subItem.lastIndexOf('-'));
      if (subItem.lastIndexOf('-') > -1) {
        this.goods_name_value = subTowItem;
      } else {
        this.goods_name_value = subItem;
      }
      this.searchData.goods_name = item.value;
    },
    clearInput() {
      this.searchData.goods_name = '';
      this.searchData.goods_label = '';
      this.goods_name_value = '';
    },
    orderSubmit() {
      this.refresh = true;
    },
  },
  computed: {
    showDeleteIcon() {
      return this.searchData.goods_label && this.searchData.goods_label !== '';
    }
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList
  },
  mounted() {
    /**
     * Description: 搜索条件初始化数据
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    this.getSearch().then((data) => {
      this.dropdownData = data;
    });
  },
};
</script>
<style scoped>
  .search-btn{
    clear: both;
    text-align: center;
    padding-bottom: 30px;
  }
  .red{
    color: #f00;
  }
</style>
